import { api } from "./base";
import { getAnyInitData, getInitDataHeaderName } from "../lib/miniApp";
/**
 * Создание платежа для покупки пакета
 * @param request - Данные для создания платежа
 * @returns Информация о созданном платеже с URL для оплаты
 */
export const createPayment = async (request) => {
    const initData = getAnyInitData();
    const headers = {};
    if (initData) {
        headers[getInitDataHeaderName()] = initData;
    }
    // Слеш в конце обязателен: роутер на бэке объявлен с `path="/"`, и без
    // слеша FastAPI отвечает 307-редиректом на версию со слешем. axios за
    // ним следует, но при строгом CORS/отключённом follow это сбоит — бьём
    // сразу по каноничному пути со слешем. (см. аудит §4)
    const response = await api.post("/api/v1/public/payments/", {
        package_id: request.package_id,
        provider: request.provider,
        ...(request.billing_email ? { billing_email: request.billing_email } : {}),
    }, {
        headers,
    });
    return response.data;
};
/**
 * Проверка статуса платежа
 * @param request - ID платежа в системе Юкасса
 * @returns Информация о платеже с текущим статусом
 */
export const checkPaymentStatus = async (request) => {
    const response = await api.post("/api/v1/payment/check-status", {
        payment_id: request.payment_id,
    });
    return response.data;
};
/**
 * Получение платежа по ID
 * @param paymentId - ID платежа
 * @returns Информация о платеже
 */
export const getPayment = async (paymentId) => {
    const response = await api.get(`/api/v1/payment/${paymentId}`);
    return response.data;
};
/**
 * Платёж по внутреннему id (PUBLIC API, cookie-сессия).
 */
export const getPublicPaymentById = async (paymentId) => {
    const response = await api.get(`/api/v1/public/payments/${paymentId}`);
    return response.data;
};
